import I18n from 'I18n';
import enviro from 'enviro';
import { updateAnthropicApiKey, updateCohereApiKey, updateGeminiApiKey, updateOpenaiApiKey, updateXaiApiKey } from './requests';
import { errorNotificationAlert, successNotificationAlert } from './alerts';
const createUpdateApiKeyRequestHandler = updateApiKey => async ({
  apiKey,
  onSuccess,
  onFailure
}) => {
  try {
    const response = await updateApiKey({
      apiKey
    });
    if (!('error' in response)) {
      successNotificationAlert();
      onSuccess();
      return;
    }
    errorNotificationAlert();
    onFailure === null || onFailure === void 0 || onFailure(response.error.chirpErrorMessage);
  } catch (error) {
    if (enviro.isQa()) {
      console.error('Failed to update API key:', error);
    }
    onFailure === null || onFailure === void 0 || onFailure(I18n.text('reconnect.aiReconnectModal.validationMessages.apiKeyGenericError'));
  }
};
export const handleAnthropicApiKeyUpdate = createUpdateApiKeyRequestHandler(updateAnthropicApiKey);
export const handleCohereApiKeyUpdate = createUpdateApiKeyRequestHandler(updateCohereApiKey);
export const handleGeminiApiKeyUpdate = createUpdateApiKeyRequestHandler(updateGeminiApiKey);
export const handleOpenaiApiKeyUpdate = createUpdateApiKeyRequestHandler(updateOpenaiApiKey);
export const handleXaiApiKeyUpdate = createUpdateApiKeyRequestHandler(updateXaiApiKey);